import { Theme } from "@mui/material";
import { TFunction } from "react-i18next";
import { PRICING_PAGE_URL } from "@features/fundamentals/constants";
import { ChartTooltip } from "@components/Tooltip/ChartTooltip";

interface Props {
  theme: Theme;
  t: TFunction;
}

export const OnlyForProChartTooltip = ({ theme, t }: Props) => {
  const bodyText = {
    fontSize: theme.typography.body3.fontSize,
    lineHeight: theme.typography.body3.lineHeight,
  };

  return (
    <ChartTooltip theme={theme}>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: theme.spacing(2),
          maxWidth: 260,
          textAlign: "center",
        }}
      >
        <div
          style={{ ...bodyText, color: theme.palette.text.onTooltipPrimary }}
        >
          {t("fundamentals.onlyForProBlock.title")}
        </div>
        <a
          href={PRICING_PAGE_URL}
          style={{
            ...bodyText,
            padding: theme.spacing(2, 3),
            borderRadius: theme.shape.borderRadius,
            background: theme.palette.button.upgradeButton.default,
            color: theme.palette.button.upgradeButton.textOnDefault,
            fontWeight: 500,
            textDecoration: "none",
          }}
        >
          {t("fundamentals.onlyForProBlock.updateToPro")}
        </a>
      </div>
    </ChartTooltip>
  );
};
